const CONSTANTS = {
    TAB_CLASS: "decor-comparison__wrapper",
    TAB_ITEM_CLASS: "decor-comparison__item",
    GROUP_COUNT: 4,
    SLIDE_TRACK: "decor-comparison__slide-track",
    SLIDE_CONTENT: "decor-comparison__slide-content"
};

const eventListener = {
    controls: (e) => {
        if (e.target.classList.contains("inactive")) {
            return;
        }
        let direction = '';
        if (e.target.classList.contains('js-next')) {
            direction = 'next'
        } else if (e.target.classList.contains('js-prev')) {
            direction = 'prev'
        } else {
            return;
        }

        const tab = e.target.closest(`.${CONSTANTS.TAB_CLASS}`);
        const items = tab.querySelectorAll(`.${CONSTANTS.TAB_ITEM_CLASS}`);
        const slideContent = tab.querySelector(`.${CONSTANTS.SLIDE_CONTENT}`);
        const slideContentPosition = Math.abs(parseInt(slideContent.style.left !== '' ? slideContent.style.left : 0));
        const slideLength = tab.clientWidth;

        if (direction === 'next') {
            const animation = slideContent.animate([
                {transform: `translateX(0px)`},
                {transform: `translateX(-${slideLength}px)`}
            ], {
                duration: 800,
                easing: "ease-in-out"
            });

            animation.onfinish = () => {
                slideContent.style.position = "relative";
                slideContent.style.left = `-${slideContentPosition + slideLength}px`;
                actions.checkControlStates(items.length, items[0].clientWidth, slideContentPosition + slideLength, tab);
            };
        }
        if (direction === 'prev') {
            const animation = slideContent.animate([
                {transform: `translateX(0px)`},
                {transform: `translateX(${slideLength}px)`}
            ], {
                duration: 800,
                easing: "ease-in-out"
            });

            animation.onfinish = () => {
                slideContent.style.position = "relative";
                slideContent.style.left = `-${slideContentPosition - slideLength}px`;
                actions.checkControlStates(items.length, items[0].clientWidth, slideContentPosition - slideLength, tab);
            };
        }
    },
};

const actions = {
    createControls: () => {
        const slideControls = document.createElement("div");
        slideControls.classList.add('js-controls');

        const btn = document.createElement("button");

        const btnNext = btn.cloneNode(true);
        btnNext.classList.add('js-next');
        btnNext.addEventListener('click', eventListener.controls);

        const btnPrev = btn.cloneNode(true);
        btnPrev.classList.add('js-prev');
        btnPrev.addEventListener('click', eventListener.controls);

        slideControls.append(btnPrev);
        slideControls.append(btnNext);

        return slideControls;
    },
    checkControlStates: (length, itemWidth, position, currentTab) => {
        const btnNext = currentTab.querySelector(`.js-next`);
        const btnPrev = currentTab.querySelector(`.js-prev`);
        if (position === 0) {
            if (!btnPrev.classList.contains('inactive')) {
                btnPrev.classList.add('inactive');
            }

            if (itemWidth * length - Math.abs(position) * 2 > 0) {
                if (btnNext.classList.contains('inactive')) {
                    btnNext.classList.remove('inactive');
                }
            } else {
                if (!btnNext.classList.contains('inactive')) {
                    btnNext.classList.add('inactive')
                }
            }
        } else {
            if (btnPrev.classList.contains('inactive')) {
                btnPrev.classList.remove('inactive');
            }

            if (itemWidth * length - Math.abs(position) * 2 > 0) {
                if (btnNext.classList.contains('inactive')) {
                    btnNext.classList.remove('inactive');
                }
            } else {
                if (!btnNext.classList.contains('inactive')) {
                    btnNext.classList.add('inactive')
                }
            }
        }
    }
};

const decorComparison = {
    init: () => {
        if (document.querySelector(".decor-comparison") !== null) {
            const tabs = document.querySelectorAll(`.${CONSTANTS.TAB_CLASS}`);
            tabs.forEach(tab => {
                const items = tab.querySelectorAll(`.${CONSTANTS.TAB_ITEM_CLASS}`);
                const sliderContent = tab.querySelector(`.${CONSTANTS.SLIDE_CONTENT}`);

                let row = tab.querySelector('.control-row');
                let col = tab.querySelector('.control-row .control-col');
                if (!col) {
                    col = document.createElement("div");
                    col.classList.add("col-lg-8", "control-col");
                }
                if (!row) {
                    row = document.createElement("div");
                    row.classList.add("row", "control-row");
                    row.append(col);
                }

                row.append(actions.createControls());

                if (items.length > CONSTANTS.GROUP_COUNT) {
                    if (!row.parent) {
                        tab.append(row);
                    }
                    actions.checkControlStates(items.length, items[0].clientWidth, sliderContent.style.left === '' ? 0 : sliderContent.style.left, tab);
                } else if (row.parent) {
                    row.remove();
                }
            });
        }
    }
};

export {decorComparison}
